module.exports = __webpack_public_path__ + "static/media/map_banner_bg.6bfdd629.png";